(function () {
    if (window.productPageTidyV1Initialized) {
        return;
    }

    window.productPageTidyV1Initialized = true;

    var scheduled = false;
    var resizeTimer = null;
    var lastVariantId = '';

    function getProductView() {
        return document.querySelector('.productView');
    }

    function getProductData() {
        var dataElement = document.getElementById('ProductAvailabilityData-v1');

        if (!dataElement) {
            return null;
        }

        try {
            return JSON.parse(dataElement.textContent || '{}');
        } catch (error) {
            return null;
        }
    }

    function getCurrentVariant(productView, productData) {
        if (!productView || !productData || !Array.isArray(productData.variants)) {
            return null;
        }

        var idInput = productView.querySelector('form[action*="/cart/add"] input[name="id"]');
        var variantId = idInput ? String(idInput.value || '') : '';

        if (!variantId && productData.selected_or_first_available_variant) {
            variantId = String(productData.selected_or_first_available_variant.id || '');
        }

        return productData.variants.find(function (variant) {
            return String(variant.id) === variantId;
        }) || null;
    }

    function updateQuantityInventoryLimit(productView) {
        var productData = getProductData();
        var variant = getCurrentVariant(productView, productData);
        var source = productView.querySelector('input[name="quantity"].quantity-dropdown-enhanced__source, input[name="quantity"][data-inventory-quantity]');
        var select = productView.querySelector('.quantity-dropdown-enhanced__select');

        if (!source || !select) {
            return;
        }

        var customInput = productView.querySelector('.quantity-dropdown-enhanced__number');
        var valueLabel = productView.querySelector('.quantity-dropdown-enhanced__value');
        var quantityGroup = select.closest('quantity-input.productView-quantity');
        var inventoryQuantity = parseInt(source.getAttribute('data-inventory-quantity'), 10);
        var ruleMaximum = variant && variant.quantity_rule && variant.quantity_rule.max ?
            parseInt(variant.quantity_rule.max, 10) : null;
        var inventoryMaximum = variant && variant.inventory_management && inventoryQuantity > 0 ?
            inventoryQuantity : null;
        var maximum = null;

        if (inventoryMaximum && ruleMaximum) {
            maximum = Math.min(inventoryMaximum, ruleMaximum);
        } else {
            maximum = inventoryMaximum || ruleMaximum;
        }

        Array.prototype.forEach.call(select.options, function (option) {
            var optionQuantity = option.value === '10-plus' ? 10 : parseInt(option.value, 10);
            var disabled = maximum !== null && optionQuantity > maximum;

            option.disabled = disabled;
            option.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        });

        if (maximum !== null) {
            source.max = String(maximum);

            if (customInput) {
                customInput.max = String(maximum);
            }
        } else {
            source.removeAttribute('max');

            if (customInput) {
                customInput.removeAttribute('max');
            }
        }

        var currentQuantity = parseInt(source.value, 10) || 1;

        if (maximum !== null && currentQuantity > maximum) {
            currentQuantity = maximum;
            source.value = String(currentQuantity);

            if (customInput) {
                customInput.value = String(currentQuantity);
            }
        }

        if (maximum !== null && maximum < 10 && quantityGroup) {
            select.classList.remove('is-hidden');
            quantityGroup.classList.remove('quantity-dropdown-show-custom');

            if (customInput) {
                customInput.classList.add('is-hidden');
            }

            select.value = String(Math.max(1, currentQuantity));
        }

        if (valueLabel) {
            valueLabel.textContent = String(Math.max(1, currentQuantity));
        }

        select.setAttribute('data-stock-maximum', maximum === null ? '' : String(maximum));
    }

    function getDeliveryData() {
        var dataElement = document.getElementById('ProductDeliveryData-v1');

        if (!dataElement) {
            return null;
        }

        try {
            return JSON.parse(dataElement.textContent || '{}');
        } catch (error) {
            return null;
        }
    }

    function updateDeliveryBox(productView) {
        var productContent = productView.querySelector('.productView-product');
        var productData = getProductData();
        var variant = getCurrentVariant(productView, productData);
        var deliveryData = getDeliveryData();
        var estimate = deliveryData && deliveryData.estimate ?
            String(deliveryData.estimate).trim() : '';
        var title = deliveryData && deliveryData.title ?
            String(deliveryData.title).trim() : 'Standard delivery';
        var available = variant ? variant.available === true :
            (productData && productData.available === true);
        var box = productContent ? productContent.querySelector('.product-delivery-box-v1') : null;

        if (!productContent || !estimate) {
            if (box) {
                box.remove();
            }
            return;
        }

        if (!box) {
            box = document.createElement('div');
            box.className = 'product-delivery-box-v1';
            box.innerHTML =
                '<span class="product-delivery-box-v1__icon" aria-hidden="true">' +
                    '<svg viewBox="0 0 24 24" focusable="false">' +
                        '<path d="M3.5 6.75 12 3l8.5 3.75v10.5L12 21l-8.5-3.75V6.75Z"></path>' +
                        '<path d="m3.8 6.9 8.2 3.6 8.2-3.6M12 10.5V21"></path>' +
                    '</svg>' +
                '</span>' +
                '<span class="product-delivery-box-v1__content">' +
                    '<span class="product-delivery-box-v1__primary-line">' +
                        '<strong class="product-delivery-box-v1__title"></strong>' +
                        '<span class="product-delivery-box-v1__estimate"></span>' +
                    '</span>' +
                    '<span class="product-delivery-box-v1__express-line">' +
                        '<span class="product-delivery-box-v1__express-question">Need Express Delivery?</span>' +
                        '<a class="product-delivery-box-v1__whatsapp" target="_blank" rel="noopener noreferrer">' +
                            '<svg class="product-delivery-box-v1__whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                                '<path d="M20.5 11.8a8.5 8.5 0 0 1-12.6 7.5l-4.4 1.2 1.2-4.3a8.5 8.5 0 1 1 15.8-4.4Z"></path>' +
                                '<path d="M8.1 7.7c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.8 1.9c.1.3 0 .5-.2.7l-.6.7c.8 1.6 1.9 2.7 3.5 3.5l.7-.8c.2-.2.5-.3.7-.2l1.8.8c.3.1.4.3.4.6v.4c0 .5-.3.9-.7 1.1-.5.3-1.1.4-1.7.3-3.5-.6-6.5-3.4-7.3-6.8-.2-.7-.1-1.5.3-2.2Z"></path>' +
                            '</svg>' +
                            '<span>Enquire Now</span>' +
                        '</a>' +
                    '</span>' +
                '</span>';

            var paymentStack = productContent.querySelector(':scope > .payment-widgets-stack-v2');
            productContent.insertBefore(box, paymentStack || null);
        }

        box.querySelector('.product-delivery-box-v1__title').textContent = title || 'Standard delivery';
        box.querySelector('.product-delivery-box-v1__estimate').textContent = estimate;

        var whatsappLink = box.querySelector('.product-delivery-box-v1__whatsapp');
        var productTitle = productData && productData.title ? productData.title : document.title;
        var whatsappMessage = 'Hello, I would like to enquire about express delivery for ' + productTitle + '.';

        whatsappLink.href = 'https://wa.me/97145591000?text=' + encodeURIComponent(whatsappMessage);
        whatsappLink.setAttribute('aria-label', 'Enquire on WhatsApp about express delivery for ' + productTitle);
        box.hidden = !available;
        box.setAttribute('aria-hidden', available ? 'false' : 'true');
    }

    function updateFloatingWhatsApp(productView) {
        var link = document.querySelector('a.floating_btn.whatsapp');

        if (!productView || !link) {
            return;
        }

        var whatsappMessage = "Hi, I’d like to know more about one of the products on your website.";

        link.href = 'https://wa.me/97145591000?text=' + encodeURIComponent(whatsappMessage);
        link.setAttribute('aria-label', 'Enquire on WhatsApp');
    }

    function fallbackAvailability(productView) {
        var button = productView.querySelector('button[name="add"], [data-btn-addtocart], .product-form__submit');

        if (!button) {
            return false;
        }

        var label = (button.textContent || button.value || '').replace(/\s+/g, ' ').trim();

        return !button.disabled &&
            button.getAttribute('aria-disabled') !== 'true' &&
            !/sold out|unavailable/i.test(label);
    }

    function updateAvailability(productView) {
        var productContent = productView.querySelector('.productView-product');

        if (!productContent) {
            return;
        }

        var productData = getProductData();
        var variant = getCurrentVariant(productView, productData);
        var available = variant ? variant.available === true :
            (productData && typeof productData.available === 'boolean' ? productData.available : fallbackAvailability(productView));
        var nativeStock = productContent.querySelector('.productView-hotStock');
        var row = nativeStock ? nativeStock.closest('.productView-moreItem') : productContent.querySelector('.product-availability-row-v1');

        if (!row) {
            row = document.createElement('div');
            row.className = 'productView-moreItem product-availability-row-v1';

            var formRow = Array.prototype.find.call(productContent.children, function (child) {
                return child.querySelector && child.querySelector('product-form, .productView-form');
            });

            productContent.insertBefore(row, formRow || productContent.firstElementChild);
        }

        row.classList.add('product-availability-row-v1');

        if (nativeStock) {
            nativeStock.setAttribute('aria-hidden', 'true');
        }

        var message = row.querySelector('.product-availability-text-v1');

        if (!message) {
            message = document.createElement('span');
            message.className = 'product-availability-text-v1';
            message.textContent = 'In Stock';
            row.appendChild(message);
        }

        message.hidden = !available;
        row.classList.toggle('is-unavailable', !available);
        row.setAttribute('aria-hidden', available ? 'false' : 'true');

        var idInput = productView.querySelector('form[action*="/cart/add"] input[name="id"]');
        lastVariantId = idInput ? String(idInput.value || '') : '';
    }

    function directChildHost(productContent, element) {
        var host = element;

        while (host && host.parentElement && host.parentElement !== productContent) {
            host = host.parentElement;
        }

        return host && host.parentElement === productContent ? host : element;
    }

    function collapseEmptyProductSpacing(productView) {
        var productContent = productView.querySelector('.productView-product');

        if (!productContent) {
            return;
        }

        Array.prototype.forEach.call(productContent.children, function (child) {
            if (!child.classList.contains('productView-moreItem') ||
                child.classList.contains('product-availability-row-v1')) {
                return;
            }

            var hasText = (child.textContent || '').replace(/\s+/g, '').length > 0;
            var hasVisibleContent = Array.prototype.some.call(
                child.querySelectorAll('*:not(script):not(style)'),
                function (element) {
                    var rect = element.getBoundingClientRect();
                    var style = window.getComputedStyle(element);

                    return rect.width > 0 && rect.height > 0 &&
                        style.display !== 'none' && style.visibility !== 'hidden';
                }
            );

            child.classList.toggle('is-empty-product-spacing-v2', !hasText && !hasVisibleContent);
        });
    }

    function groupPaymentWidgets(productView) {
        var productContent = productView.querySelector('.productView-product');
        var tabby = productContent ? productContent.querySelector('#TabbyPromo') : null;
        var tamara = productContent ? productContent.querySelector('tamara-widget') : null;

        if (!productContent || (!tabby && !tamara)) {
            productView.classList.remove('productView-payment-aligned-v2');
            return;
        }

        var stack = productContent.querySelector(':scope > .payment-widgets-stack-v2');

        if (!stack) {
            stack = document.createElement('div');
            stack.className = 'payment-widgets-stack-v2';
            productContent.appendChild(stack);
        }

        if (tabby && tabby.parentElement !== stack) {
            stack.appendChild(tabby);
        }

        if (tamara) {
            var tamaraHost = directChildHost(productContent, tamara);

            if (tamaraHost !== stack && tamaraHost.parentElement !== stack) {
                tamaraHost.classList.add('payment-widget-tamara-host-v2');
                stack.appendChild(tamaraHost);
            }
        }

        productView.classList.add('productView-payment-aligned-v2');
    }

    function alignPaymentWidgets(productView) {
        var productContent = productView.querySelector('.productView-product');
        var gallery = productView.querySelector('.halo-productView-left');
        var stack = productContent ? productContent.querySelector(':scope > .payment-widgets-stack-v2') : null;

        if (!productContent || !gallery || !stack || window.innerWidth < 768) {
            if (productContent) {
                productContent.style.removeProperty('--payment-gallery-height-v2');
            }
            return;
        }

        var productTop = productContent.getBoundingClientRect().top;
        var galleryBottom = gallery.getBoundingClientRect().bottom;
        var targetHeight = Math.max(0, Math.round(galleryBottom - productTop));

        productContent.style.setProperty('--payment-gallery-height-v2', targetHeight + 'px');
    }

    function refresh() {
        scheduled = false;

        var productView = getProductView();

        if (!productView) {
            return;
        }

        updateFloatingWhatsApp(productView);
        updateAvailability(productView);
        updateQuantityInventoryLimit(productView);
        collapseEmptyProductSpacing(productView);
        groupPaymentWidgets(productView);
        updateDeliveryBox(productView);
        alignPaymentWidgets(productView);
    }

    function scheduleRefresh() {
        if (scheduled) {
            return;
        }

        scheduled = true;
        window.requestAnimationFrame(refresh);
    }

    document.addEventListener('change', function () {
        window.setTimeout(scheduleRefresh, 0);
    }, true);

    ['variant:change', 'variant:changed', 'product:variant-change'].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleRefresh);
    });

    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(scheduleRefresh, 120);
    });

    if (window.MutationObserver) {
        new MutationObserver(scheduleRefresh).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    window.setInterval(function () {
        var productView = getProductView();
        var idInput = productView ? productView.querySelector('form[action*="/cart/add"] input[name="id"]') : null;
        var currentVariantId = idInput ? String(idInput.value || '') : '';

        if (currentVariantId !== lastVariantId) {
            scheduleRefresh();
        }
    }, 750);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
    } else {
        scheduleRefresh();
    }

    window.addEventListener('load', scheduleRefresh, { once: true });
}());
